export default {"src":"/_next/static/media/zoning_3.018a4046.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};